import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import modalService from 'services/modal';
import store, { RootState } from '../index';

const DefalutData: any = {
  // 大模型版本意图设定，模块列表
  modal_version_module_list: [],
  //  选择意图列表，同大模型同版本下 所有模块的意图（除了本身）
  select_intention_list: [],
  // 当前显示的 某个模块的 意图列表
  active_module_id: ''
};

const slice = createSlice({
  name: 'ModalVersionModule',
  initialState: DefalutData,
  reducers: {
    setModalVersionModule: (state, action: PayloadAction<any[]>) => {
      const { payload } = action;
      return { ...state, ...payload };
    }
  }
});
export const modalVersionModuleStore = (state: RootState) =>
  state.modalVersionModule;
export const { setModalVersionModule } = slice.actions;
export const dispatchSetModalVersionModule = (data: any) => {
  store.dispatch(setModalVersionModule(data));
};
// 获取其他模块的意图列表
export const getOtherConfigModuleIntentionList = async (versionId: string) => {
  let list = [];
  let res = await modalService.getVersionIntentionList(versionId);
  if (res.success) {
    list = res?.data || [];
  }
  dispatchSetModalVersionModule({
    select_intention_list: list
  });
};
export default slice.reducer;
